import { jsxs, jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { forwardRef } from 'react';
import { getColor } from '../utils/color.mjs';
import useId from './hooks/useId.mjs';
import { getID, FlexLinearGradient } from './shared/FlexLinearGradient.mjs';

const VisibilityOffAltIcon = forwardRef(
  ({
    color: rawColor = "currentColor",
    size: sizeFromProps,
    type = "default",
    style,
    ...props
  }, forwardedRef) => {
    const { id } = useId();
    const isGradient = isPresetGradientColor(rawColor);
    const color = isGradient ? `url(#${getID(rawColor, id)})` : getColor(rawColor);
    const size = sizeFromProps ?? 24;
    if (type === "fill") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M18.879 17.75 4.456 5.92 3.314 7.314 5.16 8.826a10.659 10.659 0 0 0-1.766 2.436 1 1 0 0 0 1.767.937c.421-.794.946-1.5 1.552-2.099l2.07 1.698a3.5 3.5 0 0 0 5.2 4.265l3.754 3.079 1.142-1.392ZM11.27 9.756l4.23 3.468v-.044a3.5 3.5 0 0 0-4.23-3.424Z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M7.784 6.896 9.53 8.327a6.863 6.863 0 0 1 2.428-.38h.053a6.98 6.98 0 0 1 3.903 1.084c1.2.752 2.214 1.86 2.922 3.22a1 1 0 0 0 1.775-.922c-.863-1.658-2.115-3.041-3.637-3.994a8.98 8.98 0 0 0-4.992-1.388 8.931 8.931 0 0 0-4.197.95Z"
              }
            )
          ]
        }
      );
    }
    if (type === "default") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M6.548 7.637 4.456 5.92 3.314 7.313 5.16 8.826a10.66 10.66 0 0 0-1.766 2.436 1 1 0 0 0 1.767.937c.421-.794.946-1.5 1.552-2.099l2.07 1.698a3.5 3.5 0 0 0 5.2 4.265l3.754 3.079 1.142-1.392-3.724-3.054a.349.349 0 0 0 .003-.006l-1.665-1.365v.007l-1.935-1.586.007-.002L9.9 10.379l-.004.004-1.728-1.417.005-.003-1.621-1.329-.004.003Zm3.952 5.57a1.5 1.5 0 0 0 1.768 1.449l-1.768-1.45Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "m11.27 9.756 4.23 3.468v-.044a3.5 3.5 0 0 0-4.23-3.424Z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M7.784 6.896 9.53 8.327a6.863 6.863 0 0 1 2.428-.38h.053a6.98 6.98 0 0 1 3.903 1.084c1.2.752 2.214 1.86 2.922 3.22a1 1 0 1 0 1.775-.922c-.863-1.658-2.115-3.041-3.636-3.994a8.98 8.98 0 0 0-4.993-1.388 8.931 8.931 0 0 0-4.197.95Z"
              }
            )
          ]
        }
      );
    }
    console.error(
      `VisibilityOffAltIcon doesn't support the combination of ${size} and ${type}`
    );
    return null;
  }
);

export { VisibilityOffAltIcon };
//# sourceMappingURL=VisibilityOffAltIcon.mjs.map
